import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'

export default createUIDefinition({
    taskName: taskName.VALIDATE_APPOINTMENT,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.APPOINTMENT_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
    ],
    overwriteWidget: true,
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/check-in/validate-appointment.js